import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Components
import { ScTableComponent } from './sc-table.component';

@NgModule({
  imports: [CommonModule],
  exports: [ScTableComponent],
  declarations: [ScTableComponent]
})
export class ScTableModule {}
